import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoLanguage, IoClose, IoMenu } from "react-icons/io5";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false); // ✅ drive collapse with React
  const [lang, setLang] = useState("en");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);

    // Load Google Translate script only once
    if (!document.getElementById("google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(script);
    }

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        { pageLanguage: "en", includedLanguages: "zh-CN,en" },
        "google_translate_element"
      );
    };

    // Auto-close menu if viewport goes above lg (avoid stuck 'show')
    const onResize = () => {
      if (window.innerWidth >= 992 && menuOpen) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, [menuOpen]);

  // Smooth scroll
  const smoothScrollTo = (id, offset = 60) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  // Unified menu handler — also closes the menu
  const handleMenuClick = (e, id) => {
    e.preventDefault();
    setMenuOpen(false); // ✅ hard close
    if (location.pathname === "/Nftrarity") {
      navigate("/", { replace: false });
      setTimeout(() => smoothScrollTo(id), 300);
    } else {
      smoothScrollTo(id);
    }
  };

  // Manual language toggle via Google Translate combo
  const toggleLanguage = () => {
    const select = document.querySelector(".goog-te-combo");
    if (select) {
      const newLang = lang === "en" ? "zh-CN" : "en";
      select.value = newLang;
      select.dispatchEvent(new Event("change"));
      setLang(newLang);
    }
  };

  return (
    <nav
      className={`navbar navbar-expand-lg bg-dark fixed-top shadow-sm px-4 ${
        isScrolled ? "nav-scroll" : ""
      }`}
    >
      <div className="container-fluid">
        {/* Logo */}
        <a className="navbar-brand fw-bold" href="#" onClick={() => setMenuOpen(false)}>
          <img
            src={require('../../assets/images/bearth-logo.png')}
            alt="Bearth NFT"
          />
        </a>

        {/* Toggler (no data-bs-*, driven by React) */}
        <button
        className={`navbar-toggler ${menuOpen ? "" : "collapsed"}`}
        type="button"
        aria-controls="navbarNav"
        aria-expanded={menuOpen ? "true" : "false"}
        aria-label="Toggle navigation"
        onClick={() => setMenuOpen((v) => !v)}
      >
        {menuOpen ? (
          <IoClose size={28} color="#fff" />   // ❌ close icon
        ) : (
          <IoMenu size={28} color="#fff" />    // ☰ menu icon
        )}
      </button>

        {/* Collapse (React controls the 'show' class) */}
        <div
        id="navbarNav"
        className={`navbar-collapse justify-content-end custom-collapse ${menuOpen ? "open" : ""}`}
      >
          <ul className="navbar-nav align-items-lg-center gap-3">
            <li className="nav-item">
              <a
                className="nav-link"
                href="#carouselFadeExample"
                onClick={(e) => handleMenuClick(e, "carouselFadeExample")}
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#about-home"
                onClick={(e) => handleMenuClick(e, "about-home")}
              >
                About
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#bearthstorysec"
                onClick={(e) => handleMenuClick(e, "bearthstorysec")}
              >
                Story
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#gallery2-8u"
                onClick={(e) => handleMenuClick(e, "gallery2-8u")}
              >
                Gallery
              </a>
            </li>
            <li className="nav-item">
              {location.pathname === "/Nftrarity" ? (
                <span className="nav-link active" style={{ cursor: "default" }}>
                  NFT Rarity
                </span>
              ) : (
                <a className="nav-link" href="/Nftrarity" onClick={() => setMenuOpen(false)}>
                  NFT Rarity
                </a>
              )}
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#ques-ans"
                onClick={(e) => handleMenuClick(e, "ques-ans")}
              >
                Q&amp;A
              </a>
            </li>
            <li className="nav-item">
              <a
                className="btn btn-theme-b btn-sm"
                href="https://opensea.io/collection/amg-bearth-1"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMenuOpen(false)}
              >
                NFT
              </a>
            </li>

            {/* Language toggle */}
            <li className="nav-item">
              <button onClick={toggleLanguage} className="nav-link">
                <IoLanguage /> {lang === "en" ? "中文" : "EN"}
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Hidden Google Translate div */}
      <div id="google_translate_element" style={{ display: "none" }}></div>
    </nav>
  );
};

export default Header;
